export default {
  sm: `
    각 세종의 모든 로봇은 초저지연 네트워크를 통해 클라우드를 기반으로 한 로봇 운영 시스템과 연결되어 있습니다. 
    
    ARC(아크, AI-Robot-Cloud)는 멀티 로봇 인텔리전스 시스템으로, 데이터센터 내의 모든 로봇과 자율주행셔틀의 위치와 상태를 실시간으로 모니터링하고, 공간 인프라 및 서비스와 연결합니다.
    
    ARM-System (Adaptive Robot Management-System)은 데이터센터에서 이뤄지는 각종 업무들을 로봇들이 정확하게 이해하고 지원할 수 있도록 로봇의 업무 예약과 리소스를 관리하는 시스템입니다.
    
    ARC와 ARM-System은 서로 연동되어 로봇이 효과적으로 데이터센터 안에서 주어진 업무를 수행할 수 있도록 합니다.
  `,
  lg: `
    각 세종의 모든 로봇은 초저지연 네트워크를 통해 클라우드를 기반으로 한 로봇 운영 시스템과 연결되어 있습니다. 
    
    ARC(아크, AI-Robot-Cloud)는 멀티 로봇 인텔리전스 시스템으로, 데이터센터 내의 모든 로봇과 자율주행셔틀의 위치와 상태를 실시간으로 모니터링하고, 공간 인프라 및 서비스와 연결합니다.
    
    ARM-System (Adaptive Robot Management-System)은
    데이터센터에서 이뤄지는 각종 업무들을 로봇들이 정확하게 이해하고 지원할 수 있도록 로봇의 업무 예약과 리소스를 관리하는 시스템입니다.
    
    ARC와 ARM-System은 서로 연동되어 로봇이 효과적으로 데이터센터 안에서 주어진 업무를 수행할 수 있도록 합니다.
  `,
};
